import { useAppDispatch, useAppSelector } from 'common/context/hooks';
import { orderActions } from 'context/OrderSlice';
import { useEffect, useRef } from 'react';

export const OrderManager = () => {
  const dispatch = useAppDispatch();
  const { siteEntryTime } = useAppSelector((state) => state.order);
  const audioRef = useRef<HTMLAudioElement | null>(null);

  useEffect(() => {
    audioRef.current = new Audio('/sound.wav');
    audioRef.current.volume = 0.5;
    return () => {
      if (audioRef.current) {
        audioRef.current.pause();
        audioRef.current = null;
      }
    };
  }, []);

  useEffect(() => {
    if (!siteEntryTime) {
      const now = new Date().toISOString();
      dispatch(orderActions.setSiteEntryTime(now));
    }
  }, [dispatch, siteEntryTime]);

  return null;
};
